import styled from 'styled-components';

const ArchiveDialog = styled.div`
  padding: calc(2 * ${(props): string => props.theme.spaces.lg});
  padding-top: ${(props): string => props.theme.spaces.lg};
`;

export { ArchiveDialog };
